import { lazy } from 'react';
import { authRoles } from 'src/app/auth';
const InternalDocuments = lazy(() => import('./InternalDocuments'));

const InternalDocumentsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/internal-documents',
      element: <InternalDocuments />,
    },
  ],
};

export default InternalDocumentsConfig;
